// extracted by mini-css-extract-plugin
export default {"cls1":"Attachment-cls1_tVn","cls2":"Attachment-cls2_Ap4 Attachment-cls1_tVn"};